import { render, staticRenderFns } from "./SupportStartWrapper.vue?vue&type=template&id=227a6c6c&scoped=true&"
import script from "./SupportStartWrapper.vue?vue&type=script&lang=js&"
export * from "./SupportStartWrapper.vue?vue&type=script&lang=js&"
import style0 from "./SupportStartWrapper.vue?vue&type=style&index=0&id=227a6c6c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "227a6c6c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCard,VTooltip})
